import styled from 'styled-components';

const FORMS_TEMPLATES_SECTIONS_GAP = '30px';

export const getFormsTemplatesSectionsGap = (): typeof FORMS_TEMPLATES_SECTIONS_GAP => FORMS_TEMPLATES_SECTIONS_GAP;

export const StyledFormsTemplates = styled.div`
   display: flex;
   gap: ${FORMS_TEMPLATES_SECTIONS_GAP};
   height: 100%;
   overflow: hidden;
`;
StyledFormsTemplates.displayName = 'StyledFormsTemplates';
